var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFancyRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 21,
    viewBox: "0 0 46 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4534 6.88182C36.9774 5.83452 35.658 4.84988 34.5804 3.98136C32.4212 2.25977 31.1979 0.99512 31.426 0.648796C31.654 0.302471 33.2754 0.843976 35.6828 2.01099C36.8817 2.59741 38.3296 3.40015 39.8972 4.31392L42.3306 5.766L43.6061 6.56781C43.9299 6.76507 44.2322 6.99511 44.5081 7.25429C44.8917 7.61017 45.1875 8.04941 45.373 8.53842C45.5466 9.02534 45.6023 9.5472 45.5355 10.0619C45.5035 10.3044 45.448 10.5435 45.3699 10.7759C45.3122 10.9462 45.2449 11.1132 45.1684 11.2762C44.9279 11.7615 44.6595 12.2328 44.3646 12.6879C43.8552 13.489 43.299 14.26 42.6991 14.9969C41.703 16.2359 40.5674 17.3575 39.3149 18.3396C37.1753 19.9923 35.5671 20.5281 35.3167 20.1557C35.0663 19.7833 36.127 18.5571 37.7118 16.5973C38.4576 15.6389 39.4078 14.4268 40.3257 13.0511L40.7585 12.3856C39.3353 12.6793 37.4567 12.9854 34.9526 13.2624C31.4829 13.6344 27.9979 13.8276 24.5117 13.8411C20.6602 13.8652 16.8123 13.6829 12.9846 13.295C5.67195 12.5678 -0.0529639 11.0948 0.0341356 10.6241C0.121236 10.1533 5.839 10.4931 12.9802 10.4737C20.1066 10.4775 27.2315 10.0734 34.3193 9.26341C37.2752 8.92395 39.3607 8.6764 40.8666 8.54215L40.832 8.48455L38.5271 6.85055",
    fill: "#393D4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancyRightArrow);
export default __webpack_public_path__ + "static/media/fancy-right-arrow.c229907905dcecb9f53a9ac6d5413462.svg";
export { ForwardRef as ReactComponent };